function hideAll()
{
  if(window.theEndCalled) {
    return;
  }
  hide.apply(this, ["mask","imageTarget",
    "image1","image2","image3","image4","image5","image6",
    "wordTarget",
    "word1","word2","word3","word4","word5","word6",
    "audio1",
    "video1"].concat(
      window.buttonColumns,
      ["responseBox", "responseBox2", "responseBox3", "labelBox", "labelBox2", "labelBox3", "divSurvey","divForm","title","content","trialText","trialInfo","timer","topLeft","topRight","CFPT","arrows","arrowsText","cross","divQuestionForm",
      "responseComment", "characters", "buttonComment", "extraInfo"]
    )
  );

  for (var i = 1; i <= window.stimFieldsMax; i++)
  {
    stimContainers[i] && (stimContainers[i].style.display = 'none');
  }
}

function hideImages()
{
  for (var i = 0; i <= window.stimFieldsMax; i++)
  {
    stimContainers[i].style.display="none";
  }
}


function hideMask() {
   maskContainer.style.display="none";//hide mask
}

function hideResponses() {
  //hide buttons
  hide.apply(this, window.buttonColumns.concat(["responseBox", "responseBox2", "responseBox3", "labelBox", "labelBox2", "labelBox3", "divSurvey", "responseComment", "characters", "buttonComment"]));
}